import { createSlice } from "@reduxjs/toolkit";
import { fetchCuoreCareAppointments } from "../cuoreCareThunks";

const cuoreCareSlice = createSlice({
  name: "cuoreCare",
  initialState: {
    appointments: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearCuoreCareError: (s) => {
      s.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCuoreCareAppointments.pending, (s) => {
        s.loading = true;
        s.error = null;
      })
      .addCase(fetchCuoreCareAppointments.fulfilled, (s, a) => {
        s.loading = false;
        s.appointments = a.payload || [];
      })
      .addCase(fetchCuoreCareAppointments.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload?.message || "Failed to load appointments";
      });
  },
});

export const { clearCuoreCareError } = cuoreCareSlice.actions;
export default cuoreCareSlice.reducer;
